import Handler from "../Handler";
class DealStartedHandler extends Handler {
    /** DealStarted#{"tourneyId":"lmao"} */
    // This handler is used to handle the DealStarted event.
    // The message format is:
    //   DealStarted#{"tourneyId":"lmao"}
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processDealStartedProtocol(receivedData);
  }
}
export default DealStartedHandler;
